import styled from 'styled-components';
import SkeletonCardList from './skeletonCardList';

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-date-group);
  width: 100%;
`;

interface SkeletonGroupedCardListProps {
  rows: number[];
  count?: number;
  withSubcontentOnFirstRow?: boolean;
  withHeader?: boolean;
  actionCount?: number;
}

/** Cards laid out as one date group, for the views that group their lists by day. */
const SkeletonGroupedCardList = ({
  rows,
  count = 4,
  withSubcontentOnFirstRow = false,
  withHeader = true,
  actionCount,
}: SkeletonGroupedCardListProps) => (
  <Group data-testid="grouped-cards-skeleton">
    <SkeletonCardList
      rows={rows}
      count={count}
      withSubcontentOnFirstRow={withSubcontentOnFirstRow}
      withHeader={withHeader}
      actionCount={actionCount}
    />
  </Group>
);

export default SkeletonGroupedCardList;
